export default __webpack_public_path__ + "static/media/excel-primary.772e7d4d.svg";